import React, { useEffect, useMemo, useState } from "react";

import BaseBarChart from "components/Chart/BaseBarChart";
import DivisionBox from "../../ClaimsMis/DivisionBox";
import BaseDoughnutChart from "components/Chart/BaseDoughnutChart";
import ProgressBar from "../../ClaimsMis/ProgressBar";
import RenderSummary from "../../ClaimsMis/RenderSummary";
import Header from "../../ClaimsMis/Header";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router";
import EmptyDataLottie from "components/EmptyDataLottie";
import useFetchClaims from "hooks/useFetchClaims";
import { ClaimDonwloadBtn, ClaimSummaryButton, SummaryBtnsWrapper } from "./styles";
import { usePDF } from 'react-to-pdf';
import downlaodClaimsIcon from "../../../../src/assets/svgs/downlaodClaimsIcon.svg";
import { Box } from "@mui/material";
import { OverlayLoader } from "components/core";
import { formatBackEndDateDDMMYY, formatDateToDDMMYYYY, getShortMonths, starLineWrapperJsx } from "utlis/utils";
import downloadReportIcon from "../../../assets/svgs/downlaodReportIcon.svg"
import StarSvg from "../../../assets/svgs2026/starIconSvg.svg"

function Claims() {
  const { toPDF, targetRef } = usePDF({filename: 'claims.pdf'});
  const { claims, loading } = useFetchClaims(true);

  const [data, setData] = useState({});
  const [noData, setNoData] = useState(false);

  const navigate = useNavigate();
  const redirectToClaimMIS = () => {
    navigate("/v1/claims/mis");
  };

  useEffect(async () => {
    if (!claims) return;
    setData(claims);
    if (
      (claims?.claim_analysis?.labels,
      claims?.claim_summary["Total Claims Submitted"])
    ) {
      setNoData(true);
    }
  }, [claims]);

  const getDatasets = (object_value) => {
    const { labels, ...datasets } = object_value;
    return datasets;
  };

  const sortedClaimSummary = useMemo(() => {
    if (!data.claim_summary) return [];
    const excludedKeys = ["updated_at", "Total Claims Submitted"];
    return Object.entries(data.claim_summary)
      .filter(
        ([key]) => key !== "updated_at" && key !== "Total Claims Submitted"
      )
      .sort(([, a], [, b]) => b - a)
      .map(([key]) => key);
  }, [data]);

  const adjustedClaimAnalysis = useMemo(() => {
    if (!data.claim_analysis) return {};

    const { labels, ...datasets } = data.claim_analysis;

    const newDatasets = Object.keys(datasets).reduce((acc, key) => {
      return {
        ...acc,
        [key]: {
          amounts: new Array(sortedClaimSummary.length).fill(0), // Initialize amounts array
          counts: new Array(sortedClaimSummary.length).fill(0), // Initialize counts array
        },
      };
    }, {});

    sortedClaimSummary.forEach((sortedLabel, newIndex) => {
      const originalIndex = labels.indexOf(sortedLabel);
      if (originalIndex !== -1) {
        Object.keys(datasets).forEach((datasetKey) => {
          newDatasets[datasetKey].amounts[newIndex] =
            datasets[datasetKey].amounts[originalIndex];
          newDatasets[datasetKey].counts[newIndex] =
            datasets[datasetKey].counts[originalIndex];
        });
      }
    });

    return {
      labels: sortedClaimSummary,
      ...newDatasets,
    };
  }, [data, sortedClaimSummary]);

  if(loading) {
    return <OverlayLoader />
  }

  const barWidthHandler = () => {
    const totalItems = adjustedClaimAnalysis?.labels
    if(totalItems.length <= 3) {
      return 0.2
    } else if (totalItems.length > 3 && totalItems.length < 10) {
      return 0.35
    } else {
      return 1
    }
  }

  const monthLabelsHandler = (labelsData) => {
    if(labelsData.includes("January") || labelsData.includes("january")) {
      return getShortMonths(labelsData)
    }
  }

  return (
    <>
      <div style={{ maxWidth: "1200px" }}>
        {noData ? (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "60px" }}
          >
            {/* <DivisionBox
              style={{
                height: "auto",
                display: "flex",
                flexDirection: "column",
                gap: "24px",
              }}
            > */}
            <div>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                {/* <Header last_updated_at={data?.claim_summary?.updated_at} /> */}
                {/* <span className="overview-main-header-css">{data?.claim_summary?.updated_at}</span> */}

                {/* {starLineWrapperJsx( */}
                <div style={{ display: "flex", width: "65%", alignItems: "center", gap: "5px"}}>
                  <span className="claim-summary-css">
                    Summary
                  </span>
                  <div style={{ display: "flex", alignItems: "center", width: "100%"}}>
                    <img src={StarSvg} alt="StarSvg" />
                    <div className="starLineCss" style={{ width: "100%" }} />
                  </div>
                </div>

                {/* )} */}

                {/* <SummaryBtnsWrapper>
                  <ClaimDonwloadBtn
                    variant="contained"
                    onClick={() => toPDF()}
                  >
                    <img src={downlaodClaimsIcon} />
                  </ClaimDonwloadBtn>
                  <ClaimSummaryButton
                    
                    variant="contained"
                    onClick={redirectToClaimMIS}
                    // endIcon={<ArrowForwardIcon />}
                  >
                    Detailed Summary
                  </ClaimSummaryButton>
                </SummaryBtnsWrapper> */}
                <div style={{ display: "flex", gap: "11px"}}>
                  <span
                    className="download-report-css"
                    onClick={() => toPDF()}
                  >
                    <img src={downloadReportIcon} alt="downloadReportIcon" style={{ marginRight: "6px"}} />
                    <span>
                      {"Download Report"}
                    </span>
                  </span>
                  <span
                    onClick={redirectToClaimMIS}
                    className="detailed-summary-button-css"
                  >
                    Detailed Summary
                  </span>
                </div>
              </Box>
              <span className="claim-received-text-css">
                Based on Claims data received till {data?.claim_summary?.updated_at ? formatDateToDDMMYYYY(data?.claim_summary?.updated_at) : "-"}
              </span>
              <div style={{ padding: "0px 20px 0px 20px"}}>
                <RenderSummary data={data.claim_summary} />
              </div>
            </div>
            {/* </DivisionBox> */}
            <Box
              sx={{ display: "flex", gap: "24px", flexDirection: "column" }}
              ref={targetRef}
            >
              <section 
                // style={{ display: "flex", gap: "2rem" }}
              >
                <div style={{ width: "100%" }}>
                  <DivisionBox>
                    <BaseBarChart
                      labels={adjustedClaimAnalysis?.labels}
                      datasets={getDatasets(adjustedClaimAnalysis)}
                      title="Claims Amount by Status"
                      showLabels={false}
                      showBarContentBorders={false}
                      showBarContentBordersXaxis={true}
                      stacked={true}
                      barWidthPercentage={barWidthHandler()}
                      COLORS={["#231A3D", "#4B016D", "#7F56D9", "#B692F6"]}
                    />
                  </DivisionBox>
                </div>
                {/* <div style={{ width: "40%" }}>
                  <DivisionBox>
                    <ProgressBar data={data?.ailment_wise} />
                  </DivisionBox>
                </div> */}
              </section>
              <section style={{ display: "flex", gap: "12px" }}>
                <div style={{ width: "60%" }}>
                <DivisionBox>
                  <BaseBarChart
                    // labels={data?.amount_band?.labels}
                    labels={monthLabelsHandler(data?.amount_band?.labels)}
                    datasets={getDatasets(data?.amount_band)}
                    showLabels={false}
                    title="Claims Settled by Month"
                    hideLegend
                    stacked={true}
                    combineDatasets
                    showBarContentBorders={false}
                    showBarContentBordersXaxis={true}
                    COLORS={["#4B006D", "#814D99"]}
                  />
                </DivisionBox>
                </div>
                 <div style={{ width: "40%" }}>
                  <DivisionBox>
                    <ProgressBar data={data?.ailment_wise} />
                  </DivisionBox>
                </div>
              </section>
              <section style={{ display: "flex", gap: "12px" }}>
                <DivisionBox>
                  <BaseDoughnutChart
                    labels={data?.relation_wise?.labels}
                    cutout={100}
                    radius={160}
                    datasets={getDatasets(data?.relation_wise)}
                    // title="Number of Claims Settled by Relation"
                    title="Claims Settled by Relation"
                  />
                </DivisionBox>
                <DivisionBox>
                  <BaseDoughnutChart
                    labels={data?.age_band?.label}
                    radius={220}
                    datasets={getDatasets(data?.age_band)}
                    // title="Number of Claims Settled by Age-Band"
                    title="Claims Settled by Age-Band"
                  />
                </DivisionBox>
              </section>
            </Box>
          </div>
        ) : (
          <EmptyDataLottie text="No Data Found" />
        )}
      </div>
    </>
  );
}

export default Claims;
